export default __webpack_public_path__ + "media/zurb/img/case-study-pen-cal/pencal-hero-a983da68c06adf1e6170a5a7ba4175bd.jpg";